import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';

@Component({
    selector: 'add-player',
    templateUrl: 'addPlayer.html'
})
export class AddPlayer {
  newPlayerName: String;
  

 constructor(public viewCtrl: ViewController) {

 }

   dismiss() {
      let data = { 'name': this.newPlayerName };
      this.viewCtrl.dismiss(data);
  }

  closeMe()
  {
     this.dismiss();
  }

  addPlayerButtonClicked() {
    this.dismiss();

  }

}


// WEBPACK FOOTER //
// ./src/pages/settings/addPlayer.ts